var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import InspirationsQuery from "@irati/recognition/apollo/query/Inspirations";
import { Hr } from "@irati/ui/src/Layout";
import { H3 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { InspirationModalTiles } from "../../Inspiration";
var Inspire = /** @class */ (function (_super) {
    __extends(Inspire, _super);
    function Inspire() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Inspire.prototype.render = function () {
        var tenantId = authentication.userTenant().uuid;
        var onSelect = this.props.onSelect;
        var variables = {
            tenantId: tenantId
        };
        return (React.createElement("div", null,
            React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "recognition.popup.createPoll.inspire.header" })),
            React.createElement(Hr, null),
            React.createElement(InspirationsQuery, { variables: variables }, function (_a) {
                var _b = _a.data.inspirations.results, results = _b === void 0 ? [] : _b;
                return (React.createElement(InspirationModalTiles, { inspirations: results, onClick: onSelect }));
            })));
    };
    return Inspire;
}(Component));
export default Inspire;
